import { createContext, useContext, useEffect, useState } from "react";
import { getLinks } from "./api";

const LinksContext = createContext({});

export function LinksProvider({ children }) {
  const [links, setLinks] = useState({});
  useEffect(() => {
    getLinks().then(setLinks).catch(() => {});
  }, []);
  return <LinksContext.Provider value={links}>{children}</LinksContext.Provider>;
}

export const useLinks = () => useContext(LinksContext);
